export default __webpack_public_path__ + "static/media/error-icon-circle.d911d7dd.svg";